export class TipoLicenciaMaternidadConstants {
  static LIC_45_45 = "45-45";
  static LIC_30_60 = "30-60";
}
